"use client";
import { useMediaQuery } from "@mui/material";
import Image from "next/image";
import { useTranslation } from "@/app/i18n/client";
import mobileMock from "@/assets/images/landing/hexagon-with-mobile.webp";
import AppleIcon from "@/assets/images/logos/Apple_logo.svg";
import GooglePlayIcon from "@/assets/images/logos/google_play_icon.svg";
import CustomButton from "@/common/customElements/button";
import { CustomDiv, InlineDiv } from "@/common/divs";
import { LightText, RegularText, SemiBoldText } from "@/common/texts";
import { NEUTRO_TITLES_COLOR, PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const LandingMobile: React.FC = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 550px)");
  return (
    <InlineDiv
      paddingX="108px"
      className="mobile-global-container global-padding"
    >
      <CustomDiv
        className="section-mobile mobile-background-landing"
        style={{
          justifyContent: "center",
          height: "auto",
        }}
      >
        <Image
          src={mobileMock}
          alt="Mobile mockup"
          width={0}
          height={0}
          style={{
            height: "auto",
            width: "100%",
          }}
        />
      </CustomDiv>
      <CustomDiv
        className="section-mobile download-mobile-landing-container"
        background="#FFF7E4"
      >
        <SemiBoldText
          fontSize="24px"
          style={{ lineHeight: "30px", maxWidth: "400px" }}
        >
          {t("landing.download_title")}
        </SemiBoldText>
        <LightText
          style={{ marginTop: "30px", lineHeight: "30px", maxWidth: "400px" }}
          fontSize="24px"
        >
          {t("landing.select_and_book")}
        </LightText>
        <LightText style={{ marginTop: "10px" }}>
          {t("landing.discount")}
        </LightText>
        <InlineDiv style={{ gap: "15px", marginTop: "10px", flexWrap: "wrap" }}>
          <div className="max-width-on-mobile-landing">
            <CustomButton
              marginY="7px"
              width={isMobile ? "100%" : "197px"}
              height="50px"
              backgroundColor={PRIMARY_BUTTON_COLOR}
              onClick={() => {
                window.open(
                  "https://play.google.com/store/apps/details?id=com.vee.traveler&hl=es_es&pli=1",
                  "_blank",
                  "noreferrer",
                );
              }}
            >
              <InlineDiv style={{ alignItems: "center" }}>
                <Image
                  src={GooglePlayIcon.src}
                  alt="googlePlay"
                  width={25}
                  height={27}
                  style={{
                    marginRight: "8px",
                    width: "25px",
                    height: "27px",
                  }}
                />
                <div>
                  <LightText fontSize="14px" color={NEUTRO_TITLES_COLOR}>
                    {t("footer.available")}
                  </LightText>
                  <RegularText fontSize="14px" color={NEUTRO_TITLES_COLOR}>
                    Google Play
                  </RegularText>
                </div>
              </InlineDiv>
            </CustomButton>
          </div>
          <div className="max-width-on-mobile-landing">
            <CustomButton
              marginY="7px"
              width={isMobile ? "100%" : "197px"}
              height="50px"
              onClick={() => {
                window.open(
                  "https://apps.apple.com/es/app/vee-sightseeing/id1625223257",
                  "_blank",
                  "noreferrer",
                );
              }}
              backgroundColor={PRIMARY_BUTTON_COLOR}
            >
              <InlineDiv style={{ alignItems: "center" }}>
                <Image
                  src={AppleIcon.src}
                  alt="apple"
                  width={25}
                  height={25}
                  style={{
                    marginRight: "8px",
                    width: "25px",
                    height: "25px",
                  }}
                />
                <div>
                  <LightText fontSize="14px" color={NEUTRO_TITLES_COLOR}>
                    {t("footer.available")}
                  </LightText>
                  <RegularText fontSize="14px" color={NEUTRO_TITLES_COLOR}>
                    App store
                  </RegularText>
                </div>
              </InlineDiv>
            </CustomButton>
          </div>
        </InlineDiv>
      </CustomDiv>
    </InlineDiv>
  );
};
export default LandingMobile;
